import { Type } from "class-transformer";
import { PagedResults } from "@abaco/web-common/src/Paging";

export class Proposal {
    proposal_code!: string;
    proposal_sub_code!: string;
    proposal_description!: string;
    proposal_long_description!: string;
}

export class Proposals {
    @Type(() => Proposal)
    proposals: Proposal[] = [];
    more_rows = false;
}

export class Unimi {
    unimis_code!: string;
    unimis_sub_code!: string;
    unimis_description!: string;
    unimis_long_description!: string;
}

export class Unimis {
    @Type(() => Unimi)
    unimis: Unimi[] = [];
    more_rows = false;
}

export class SimpleCost {
    investment_code!: string;
    investment_sub_code!: string;
    investment_description!: string;
    simple_cost_code!: string;
    simple_cost_sub_code!: string;
    simple_cost_description!: string;
    simple_cost_vat_percentage!: number;
    simple_cost_formula!: string;
    simple_cost_unit!: string;
}
export class SimpleCosts implements PagedResults<SimpleCost> {
    totalcount = 0;
    offset = 0;
    @Type(() => SimpleCost)
    records: SimpleCost[] = [];
    count = 0;
}

export class Action {
    action_id!: number;
    action_code!: string;
    action_description!: string;
    action_long_description!: string;
}

export class Actions {
    @Type(() => Action)
    actions: Action[] = [];
    more_rows = false;
}

export class Activity {
    activity_code!: string;
    activity_sub_code!: string;
    activity_description!: string;
    activity_long_description?: string;
}

export class Activities implements PagedResults<Activity> {
    totalcount = 0;
    offset = 0;
    @Type(() => Activity)
    records: Activity[] = [];
    count = 0;
}

export class Expenditure {
    expenditure_code!: string;
    expenditure_sub_code!: string;
    expenditure_description!: string;
    expenditure_long_description?: string;
}

export class Expenditures implements PagedResults<Expenditure> {
    totalcount = 0;
    offset = 0;
    @Type(() => Expenditure)
    records: Expenditure[] = [];
    count = 0;
}

export class Investment {
    investment_code!: string;
    investment_sub_code!: string;
    investment_description!: string;
    investment_simple_cost!: number;
    investment_visible_locality!: number;


    get isSimpleCost(): boolean {
        return !!this.investment_simple_cost;
    }

    get isVisibleLocality(): boolean {
        return !!this.investment_visible_locality;
    }
}

export class Investments implements PagedResults<Investment> {
    totalcount = 0;
    offset = 0;
    @Type(() => Investment)
    records: Investment[] = [];
    count = 0;
}

export class Locality {
    codi_fisc_luna!: string | null;
    istat_comune!: string;
    istat_provincia!: string;
    locality_description!: string;
}

export class Localities implements PagedResults<Locality> {
    totalcount = 0;
    offset = 0;
    @Type(() => Locality)
    records: Locality[] = [];
    count = 0;
}

export class Category {
    id_category!: number;
    titolo!: string;
}

export class Categories implements PagedResults<Category> {
    totalcount = 0;
    offset = 0;
    @Type(() => Category)
    records: Category[] = [];
    count = 0;
}


export class WorkComponent {
    investment_id!: string;
    titolo!: string;
}

export class WorkComponents implements PagedResults<WorkComponent> {
    totalcount = 0;
    offset = 0;
    @Type(() => WorkComponent)
    records: WorkComponent[] = [];
    count = 0;
}


export class LegalNature {
    codice!: number;
    codice_esterno!: number;
    descrizione!: string;
    flag_individuale!: string;
    flag_persona!: string;
}
export class LegalNatures implements PagedResults<LegalNature> {
    totalcount = 0;
    offset = 0;
    @Type(() => LegalNature)
    records: LegalNature[] = [];
    count = 0;
}

export class PartnershipType {
    sotto_codice!: string;
    ds_decodifica!: string;
}
export class PartnershipTypes implements PagedResults<PartnershipType> {
    totalcount = 0;
    offset = 0;
    @Type(() => PartnershipType)
    records: PartnershipType[] = [];
    count = 0;
}

export class Person {
    title!: string | null;
    name!: string | null;
    surname!: string | null;
    fiscal_code!: string | null;
    mobile_number!: string | null;
    email_address!: string | null;
    website!: string | null;
    position!: string | null;
    position_sotto_codice!: string | null;
    address!: string | null;
    address2!: string | null;
    address3!: string | null;
    cod_belf_residenza!: string | null;
    locality_description!: string | null;
}

export class Persons implements PagedResults<Person> {
    totalcount = 0;
    offset = 0;
    @Type(() => Person)
    records: Person[] = [];
    count = 0;
}

export class Position {
    sotto_codice!: string;
    ds_decodifica!: string;
}
export class Positions implements PagedResults<Position> {
    totalcount = 0;
    offset = 0;
    @Type(() => Position)
    records: Position[] = [];
    count = 0;
}

export class ContactType {
    sotto_codice!: string;
    ds_decodifica!: string;
}
export class ContactTypes implements PagedResults<ContactType> {
    totalcount = 0;
    offset = 0;
    @Type(() => ContactType)
    records: ContactType[] = [];
    count = 0;
}

export class ContactOtherType {
    sotto_codice!: string;
    ds_decodifica!: string;
}
export class ContactOtherTypes implements PagedResults<ContactOtherType> {
    totalcount = 0;
    offset = 0;
    @Type(() => ContactOtherType)
    records: ContactOtherType[] = [];
    count = 0;
}

export class Product {
    year!: number | null;
    region!: string | null;
    region_name!: string | null;
    field_id!: string | null;
    unit!: string | null;
    agricultural_product!: string | null;
    coefficient!: number | null;
    cod_fonte_dati!: string | null;
    sco_fonte_dati!: string | null;
    fg_valido_inizio!: string | null;
    fg_valido_fine!: string | null;
    id_atto_inizio!: number | null;
    id_atto_fine!: number | null;
    dt_ultimo_agg!: number | null;
    utente!: string | null;
}

export class Products implements PagedResults<Product> {
    totalcount = 0;
    offset = 0;
    @Type(() => Product)
    records: Product[] = [];
    count = 0;
}

export class EIPTarget {
    sotto_codice!: string;
    ds_decodifica!: string;
}
export class EIPTargets implements PagedResults<EIPTarget> {
    totalcount = 0;
    offset = 0;
    @Type(() => EIPTarget)
    records: EIPTarget[] = [];
    count = 0;
}

export class EIPRole {
    sotto_codice!: string;
    ds_decodifica!: string;
}
export class EIPRoles implements PagedResults<EIPRole> {
    totalcount = 0;
    offset = 0;
    @Type(() => EIPRole)
    records: EIPRole[] = [];
    count = 0;
}
